/**
 * NomealIcon — sanitized from `assets/newSvg/nomeal.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function NomealIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12,2 C11.4477,2 11,2.44772 11,3 L11,5 L5,5 C3.89543,5 3,5.89543 3,7 L3,20 C3,21.1046 3.89543,22 5,22 L19,22 C20.1046,22 21,21.1046 21,20 L21,7 C21,5.89543 20.1046,5 19,5 L13,5 L13,3 C13,2.44772 12.5523,2 12,2 Z M13,5 L13,13.8284 L14.8284,12 C15.219,11.6095 15.8521,11.6095 16.2426,12 C16.6332,12.3905 16.6332,13.0237 16.2426,13.4142 L12.8839,16.773 C12.3957,17.2611 11.6043,17.2611 11.1161,16.773 L7.75736,13.4142 C7.36684,13.0237 7.36684,12.3905 7.75736,12 C8.14788,11.6095 8.78105,11.6095 9.17157,12 L11,13.8284 L11,5 L13,5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default NomealIcon;
